import { Link } from "react-router-dom";
import "./Menus.css"

export default function Menus({menu1,menu2,link1,link2}) {
    return (
        <div className="menus_container">
           <div className="menuOne"><Link to={link1}>{menu1}</Link></div> <div className="menuTwo"><Link to={link2}>{menu2}</Link></div>
        </div>
    );
}